import axios from "axios";
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import FeatherIcon from "feather-icons-react";
import Modal from "react-bootstrap/Modal";
import Resizer from "react-image-file-resizer";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Year from "../years/Year";
class Establishment extends Component {
  state = {
    establishment: {}, image: [], isModal: false, dataImage: null, btn: false,
    name: '', short_name: '', tel: '', email: '', mailbox: '', slogan: '',
    identifiant_agree: '', country: '', countryCode: '', region: '', city: '',
    municipality: '', neighborhood: '', avenue: '', other_adress : '',
    tax_center: '', logo: '', error: '',
  };

  componentDidMount() { this.getEstablishment(); }

  getEstablishment = async () => {
    try {
      const establishmentId = JSON.parse(localStorage.getItem("establishmentId") || "");
      const id = establishmentId || null;
      if (!id) return;
      const response = await axios.get(`establishments/${id}`);
      if (response.status === 200) {
        const e = response.data || {};
        this.setState({
          establishment: e, name: e.name || "", short_name: e.short_name || "",
          tel: e.tel || '', email: e.email || '', mailbox: e.mailbox || '',
          slogan: e.slogan || '', identifiant_agree: e.identifiant_agree || '',
          country: e.country || '', countryCode: e.countryCode || '',
          region: e.region || '', city: e.city || '',
          municipality: e.municipality || '', neighborhood: e.neighborhood || '',
          avenue: e.avenue || '', other_adress: e.other_adress || '',
          tax_center: e.tax_center || '', logo: e.logo || '',
          countryCode: e.countryCode || '',
        });
        localStorage.setItem("establishment", JSON.stringify(e));
      }
    } catch (error) {
      this.setState({ error: "Impossible de charger les informations de l’établissement." });
    }
  };

  showModal = () => this.setState((state) => ({ isModal: !state.isModal, error: "" }));
  handleInput = (event) => this.setState({ [event.target.name]: event.target.value });

  storeEstablishment = async () => {
    this.setState({ error: "", btn: true });
    const formData = new FormData();
    if (this.state.dataImage) formData.append("files", this.state.dataImage);
    ['name', 'short_name', 'tel', 'email', 'mailbox', 'slogan',
      'identifiant_agree', 'country', 'countryCode', 'region', 'city',
      'municipality', 'neighborhood', 'avenue', 'other_adress', 'tax_center'].forEach((key) =>
      formData.append(key, this.state[key] || ""));
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const response = await fetch(`${process.env.REACT_APP_APIEVIVESOMA}/establishments/${this.state.establishment.id}`, {
        method: "PUT", headers: { "x-access-token": user.refresh_token || "" }, body: formData,
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.msg || "La mise à jour a échoué.");
      }
      toast.success("Établissement mis à jour avec succès.");
      this.setState({ isModal: false, btn: false, image: [], dataImage: null }, this.getEstablishment);
    } catch (error) {
      this.setState({ error: error.message, btn: false });
      toast.error(error.message);
    }
  };

  handleInputFile = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    this.setState({ dataImage: file, image: [] });
    Resizer.imageFileResizer(file, 700, 700, "JPEG", 82, 0,
      (uri) => this.setState({ image: [uri] }), "base64", 700, 700);
  };

  handleCheck(permission) {
    try {
      return JSON.parse(localStorage.getItem("permissions") || "[]").some((item) => permission === item.permission);
    } catch (error) { return false; }
  }
  render() {
    const e = this.state.establishment;
    const location = [e.avenue, e.neighborhood, e.municipality, e.city, e.region, e.country]
      .filter(Boolean).join(', ');
    const identityFields = [
      ['name', 'Nom complet', 'text', true],
      ['short_name', 'Abréviation'],
      ['tel', 'Téléphone', 'tel', true],
      ['email', 'Adresse e-mail', 'email'],
      ['mailbox', 'Boîte postale'],
      ['slogan', 'Devise / slogan'],
      ['identifiant_agree', 'Numéro d’agrément'],
      ['tax_center', 'Centre fiscal'],
    ];
    const addressFields = [
      ['country', 'Pays'],
      ['countryCode', 'Code du pays'],
      ['region', 'Région / province'],
      ['city', 'Ville'],
      ['municipality', 'Commune'],
      ['neighborhood', 'Quartier'],
      ['avenue', 'Avenue'],
      ['other_adress', 'Complément d’adresse'],
    ];
    return (
      <main className="container establishment-page">
        <Helmet><title>{process.env.REACT_APP_NAME} | Établissement</title></Helmet>
        <header className="establishment-hero">
          <div className="establishment-hero__seal"><FeatherIcon icon="book-open" size={22} /></div>
          <div className="establishment-hero__copy">
            <span className="establishment-eyebrow">Identité institutionnelle</span>
            <h1>Votre établissement</h1>
            <p>La carte d’identité officielle de votre structure scolaire.</p>
          </div>
          <Link to="/manuel#establishments" className="establishment-edit">
            <FeatherIcon icon="help-circle" size={17} /> Doc
          </Link>
          <button type="button" className="establishment-edit" onClick={this.showModal}>
            <FeatherIcon icon="edit-3" size={17} /> Modifier la fiche
          </button>
        </header>

        <section className="establishment-profile">
          <div className="establishment-profile__identity">
            <div className="establishment-logo">
              {e.logo ? <img src={e.logo} alt={`Logo ${e.name || "de l’établissement"}`} /> : <FeatherIcon icon="home" size={46} />}
            </div>
            <div>
              <h2>{e.name || "Nom de l’établissement"}</h2>
              {e.short_name && <strong>{e.short_name} - {e.countryCode}</strong>}
              <p>{e.slogan || "La devise de votre établissement apparaîtra ici."}</p>
            </div>
          </div>
          <div className="establishment-profile__facts">
            <article><i><FeatherIcon icon="map-pin" size={19} /></i><div><span>Localisation</span><b>{location || "Non renseignée"}</b></div></article>
            <article><i><FeatherIcon icon="phone" size={19} /></i><div><span>Téléphone</span>{e.tel ? <a href={`tel:${e.tel}`}>{e.tel}</a> : <b>Non renseigné</b>}</div></article>
            <article><i><FeatherIcon icon="mail" size={19} /></i><div><span>Adresse e-mail</span>{e.email ? <a href={`mailto:${e.email}`}>{e.email}</a> : <b>Non renseignée</b>}</div></article>
            <article><i><FeatherIcon icon="award" size={19} /></i><div><span>Agrément</span><b>{e.identifiant_agree || "Non renseigné"}</b></div></article>
          </div>
          <div className="establishment-profile__footer">
            <span><FeatherIcon icon="inbox" size={15} /> {e.mailbox || "Boîte postale non renseignée"}</span>
          </div>
        </section>

        {this.handleCheck("Afficher année") && e.id && (
          <section className="establishment-years">
            <div className="establishment-section-title"><i><FeatherIcon icon="calendar" size={19} /></i><div><span>Organisation scolaire</span><h2>Années scolaires</h2></div></div>
            
            <Year />
          </section>
        )}

        <Modal show={this.state.isModal} onHide={this.showModal} size="lg" backdrop="static"
          dialogClassName="student-form-dialog"
          contentClassName="student-form-modal student-form-modal--compact">
          <Modal.Header>
            <div className="student-form__heading">
              <span className="student-form__heading-icon"><FeatherIcon icon="home" size={20} /></span>
              <div>
                <span className="student-form__eyebrow">Paramètres de l’établissement</span>
                <Modal.Title>Mettre à jour la fiche</Modal.Title>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className="row student-form__body">
            {this.state.error && <div className="col-12"><div className="student-form__alert" role="alert"><FeatherIcon icon="alert-circle" size={17} /><span>{this.state.error}</span></div></div>}
            <div className="col-12 student-form__section-title">
              <span><FeatherIcon icon="home" size={16} /></span>
              <div><strong>Identité et contacts</strong><small>Informations officielles de l’établissement</small></div>
            </div>
            {identityFields.map(([name, label, type = 'text', required = false]) => (
              <div className="form-group col-md-6 mt-2" key={name}>
                <label htmlFor={`establishment-${name}`}>{label}{required && <span className="text-danger">*</span>}</label>
                <input id={`establishment-${name}`} type={type} className="form-control" onChange={this.handleInput} name={name} value={this.state[name] || ''} required={required} />
              </div>
            ))}
            <div className="col-12 student-form__section-title">
              <span><FeatherIcon icon="map-pin" size={16} /></span>
              <div><strong>Adresse</strong><small>Localisation administrative et postale</small></div>
            </div>
            {addressFields.map(([name, label]) => (
              <div className="form-group col-md-6 mt-2" key={name}>
                <label htmlFor={`establishment-${name}`}>{label}</label>
                <input id={`establishment-${name}`} type="text" className="form-control" onChange={this.handleInput} name={name} value={this.state[name] || ''} />
              </div>
            ))}
            <div className="col-12 student-form__section-title">
              <span><FeatherIcon icon="image" size={16} /></span>
              <div><strong>Logo</strong><small>Formats PNG, JPG ou JPEG — 5 Mo maximum</small></div>
            </div>
            <div className="form-group col-12 mt-2">
              <label htmlFor="establishment-logo">Logo de l’établissement</label>
              <input id="establishment-logo" type="file" className="form-control" accept=".png,.jpg,.jpeg,image/png,image/jpeg" onChange={this.handleInputFile} />
              {this.state.image[0] && <div className="mt-2">
                <img src={this.state.image[0]} alt="Aperçu du nouveau logo" width="72" height="72" style={{ objectFit: 'contain' }} />
              </div>}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <span className="student-form__footer-note"><FeatherIcon icon="info" size={14} /> Les champs marqués d’un * sont obligatoires</span>
            <button type="button" onClick={this.showModal} className="btn btn-light student-form__button"><FeatherIcon icon="x" size={16} /> Annuler</button>
            <button type="button" onClick={this.storeEstablishment} disabled={this.state.btn} className="btn btn-primary student-form__button"><FeatherIcon icon={this.state.btn ? "loader" : "check"} size={16} />{this.state.btn ? "Enregistrement…" : "Enregistrer"}</button>
          </Modal.Footer>
        </Modal>
      </main>
    );
  }
}
export default Establishment;
